document.addEventListener("DOMContentLoaded", function () {
  initReveal();
  initMarquees();
});

function initReveal() {
  var els = document.querySelectorAll(".mt-reveal");
  if (!els.length) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    els.forEach(function (el) { el.classList.add("mt-visible"); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute("data-mt-delay") || 0;
          setTimeout(function () { entry.target.classList.add("mt-visible"); }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initMarquees() {
  var tracks = document.querySelectorAll("[data-mt-marquee]");
  if (!tracks.length) return;
  tracks.forEach(function (track) {
    var speed = Number(track.getAttribute("data-mt-marquee")) || 40;
    track.style.animationDuration = speed + "s";
  });
}
